import React from 'react'
import Head from '../../layout/head/Head'

const AdminDashboard = () => {
  return (
   <>
   <Head title={'Admin Dashboard'}/>
   
   </>
  )
}

export default AdminDashboard